// src/api/productApi.js
import { get, post, del, put } from "./api"; // Import GET and POST functions

export const ProductsAPI = {
  list() {
    return get(`/products`);
  },
  insights() {
    return get(`/products/insights`);
  },
  create(payload) {
    return post(`/products`, payload);
  },
  update(id, payload) {
    return put(`/products/${id}`, payload);
  },
  remove(id) {
    return del(`/products/${id}`);
  },
};
